import { useCaptureReceipts } from '@/db/hooks'
import { CaptureRow } from '@/components/Captures'
import { Empty, PageTitle } from '@/components/ui'
import { fmtDateShort, todayLocal } from '@/lib/time'
import { AppTabs, HISTORY_TABS } from '@/components/AppTabs'

const localDay = (iso: string) => {
  const d = new Date(iso)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * History → Captures: every capture Prime looked at, newest first and grouped
 * by day, so "what did she ask me to do on Tuesday" has one answer. What still
 * waits on the owner is in the Inbox ("Waiting for you"); this is the record.
 */
export const CapturesView = () => {
  const receipts = useCaptureReceipts()
  const today = todayLocal()
  const groups: { day: string; items: typeof receipts }[] = []
  for (const s of receipts) {
    const day = localDay(s.created_at)
    const g = groups[groups.length - 1]
    if (g && g.day === day) g.items.push(s)
    else groups.push({ day, items: [s] })
  }
  return (
    <div data-testid="captures">
      <PageTitle>History</PageTitle>
      <AppTabs tabs={HISTORY_TABS} label="History" />
      {receipts.length === 0 ? (
        <Empty icon="📥">
          No captures yet. With “Let the assistant file captures” on, each one waits in the Inbox with what
          Prime suggests, and lands here once it has.
        </Empty>
      ) : (
        groups.map((g) => (
          <section key={g.day} className="mb-5">
            <h2 className="text-[13px] font-semibold text-muted mb-2">{fmtDateShort(g.day, today)}</h2>
            <ul className="group-list">
              {g.items.map((s) => (
                <CaptureRow key={s.id} s={s} />
              ))}
            </ul>
          </section>
        ))
      )}
    </div>
  )
}
